import React from 'react';

import { APP_DOWNLOAD_URL } from '../constants/constants';

const AppDownload = () => {
  return (
    <div className="app-download">
      <p className="text-center">
        ¡No olvides descargar la app para obtener todos los beneficios de tu seguro Amae!
      </p>
      <a href={APP_DOWNLOAD_URL} className="btn" target="_blank" rel="noreferrer">Descargar</a>
    </div>
  );
};

export default AppDownload;
